export function initializeSplitContent() {
  // wadd css class to parent container if there is child image
  function imageBackgroundOverlay() {
    if (document.querySelector('.split-content')) {
      const splitContent = document.querySelector('.split-content');
      const bgImages = splitContent.querySelectorAll('.background-image');

      [...bgImages].forEach((bgImage) => {
        bgImage.closest('.content').classList.add('has-image');
      });
    }
  }

  imageBackgroundOverlay();
}
